const faqNav = () => {
  const nav = document.getElementById('faq-page-nav');
  if (!nav) return;

  const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
  if (!links.length) return;

  const items = links
    .map((link) => {
      const id = link.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      return target ? { link, target, parent: link.parentElement } : null;
    })
    .filter(Boolean);

  if (!items.length) return;

  const setActive = (activeItem) => {
    items.forEach(({ parent }) => parent.classList.remove('is-active'));
    if (activeItem) activeItem.parent.classList.add('is-active');
  };

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => a.target.offsetTop - b.target.offsetTop);

      if (visible.length) {
        const current = items.find((i) => i.target === visible[0].target);
        if (current) setActive(current);
      }
    },
    {
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0,
    }
  );

  items.forEach(({ target }) => observer.observe(target));

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      const id = link.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', `#${id}`);
    });
  });
};

document.addEventListener('DOMContentLoaded', faqNav);

export default faqNav;
